import { FC } from 'react';

import { last } from 'lodash';
import { cn } from 'utils/helpers';
import dayjs from 'dayjs';
import {
  useGmailBulkMarkAsRead,
  useGmailGetThread,
} from 'modules/account/inbox/hooks';

import EmailPanelSkeleton from '../../EmailThreadPanel/EmailSkeleton';
import SimpleEmailEntry from './SimpleEmailEntry';

type GmailEntryProps = {
  data: { id: string; selectedEmailAddress: string };
  onClick?: () => void;
};

const GmailEntry: FC<GmailEntryProps> = ({ data, onClick }) => {
  const { data: threadData, isLoading } = useGmailGetThread(data?.id, {
    format: 'metadata',
    from: data?.selectedEmailAddress,
  });
  const { mutate: markAsRead } = useGmailBulkMarkAsRead();
  const lastMessage = last(threadData?.messages);

  if (!lastMessage || isLoading) {
    return (
      <div
        className={cn(
          'text-secondary ',
          'text-left w-full',
          'rounded-[6px]',
          'bg-fill-tertiary',
        )}
      >
        <EmailPanelSkeleton count={1} />
      </div>
    );
  }

  const unreadMessages = threadData?.messages
    .filter((message) => message.labelIds.includes?.('UNREAD'))
    ?.map(({ id }) => id);

  const _onClick = () => {
    onClick?.();
    if (unreadMessages?.length && unreadMessages?.length > 0) {
      markAsRead({
        messageIds: unreadMessages,
        threadId: data?.id,
        from: data?.selectedEmailAddress,
      });
    }
  };

  const subject = lastMessage?.payload?.headers?.find(
    (header) => header.name === 'Subject',
  )?.value;
  const date = dayjs(
    lastMessage?.payload?.headers?.find((header) => header.name === 'Date')
      ?.value,
  ).format('ll LT');
  const isUnread = lastMessage?.labelIds?.includes?.('UNREAD');
  const { snippet } = lastMessage;

  return (
    <SimpleEmailEntry
      isUnread={isUnread}
      isLoading={isLoading}
      date={date}
      subject={subject ?? ''}
      onClick={_onClick}
      snippet={snippet}
    />
  );
};

export default GmailEntry;
